/* Pack Builder B2B Override Script */
(function() {
  const allowed = ["Gardencups", "Snacks", "Soups", "Produce", "Add-Ons"];

  const vegetarianProducts = [
    "Garden Harvest Salad",
    "Southwest Salad",
    "Mediterranean Salad",
    "Caprese Salad",
    "Asian Chopped Salad",
    "Pesto Pasta Bowl",
    "Italian Pasta Bowl",
    "Soba Noodle Bowl w/ Garlic Butter Tofu",
   ];

  const saladSections = [
    "Gardencups w/Protein",
    "Powercups w/Protein",
    "Gardencups (veggie)",
    "Powercups (veggie)",
  ];

  const rename = {
    Soupcups: "Soups",
    Producecups: "Produce",
    Snackcups: "Snacks",
    Salads: "Gardencups",
    "Gardencups w/Protein": "Gardencups",
  };
  
  const categoryMap = {
      'salads': ['Gardencups'],
      'bowls': ['Powercups'],
      'soups': ['Soupcups'],
      'produce': ['Producecups'],
      'snacks': ['Snackcups'],
      'addons': ['Dipcups', 'Cold-Pressed Juice', 'Add-Ons']
  };

  const txt = (el) => (el && el.textContent ? el.textContent.trim() : "");

  const anchorId = (label) =>
    `pb-section-${label.toLowerCase().replace(/\s+/g, "-")}`;

  const isPrefillNode = (el) => Boolean(el?.closest?.("[data-pb-prefill]"));

  const isLiveCollection = (el) => Boolean(el?.querySelector?.("[data-product-id]"));

  const collections = () =>
    Array.from(document.querySelectorAll(".pb__collection")).filter(
      (c) => !isPrefillNode(c) && isLiveCollection(c)
    );

  const titleEl = (c) => c && c.querySelector(".pb__collection-title");

  const byTitle = (t) =>
    collections().find((c) => txt(titleEl(c)) === t);

  const titlesReady = () => {
    const wrap = document.querySelector(".pb__collections");
    if (!wrap) return false;
    return !!wrap.querySelector(".pb__collection [data-product-id]");
  };

  const mergeGardencups = () => {
    const main =
      byTitle("Gardencups w/Protein") ||
      byTitle("Salads") ||
      byTitle("Gardencups");

    if (!main) return;
    if (main.classList.contains("merged-collection")) return;

    const list = main.querySelector(".pb__collection-products");
    if (!list) return;

    main.classList.add("merged-collection");

    const h = titleEl(main);
    if (h) h.textContent = "Gardencups";

    saladSections.forEach((name) => {
      if (name === "Gardencups w/Protein") return;

      const sec = byTitle(name);
      if (!sec) return;

      sec.querySelectorAll(".pb__product-container").forEach((p) => {
        list.appendChild(p);
      });

      sec.remove();
    });
  };

  const fixHeaders = () => {
    collections().forEach((c) => {
      const h = titleEl(c);
      const t = txt(h);
      if (rename[t]) h.textContent = rename[t];
    });
  };

  const ensureSectionAnchors = () => {
    collections().forEach((c) => {
      const label = txt(titleEl(c));
      if (!allowed.includes(label)) return;
      c.id = anchorId(label);
    });
  };

  const reorderSections = () => {
    const wrap = document.querySelector(".pb__collections");
    if (!wrap) return;

    const map = {};
    collections().forEach((c) => {
      const label = txt(titleEl(c));
      if (allowed.includes(label) && !map[label]) map[label] = c;
    });

    const ordered = allowed.map((label) => map[label]).filter(Boolean);
    const currentCollections = Array.from(wrap.querySelectorAll(":scope > .pb__collection"));
    const alreadyOrdered =
      ordered.length === currentCollections.length &&
      ordered.every((el, index) => el === currentCollections[index]);

    if (alreadyOrdered) return;

    ordered.forEach((el) => wrap.appendChild(el));
  };

  const fixJumpLinks = () => {
    const wrap = document.querySelector(".pb__jump-links");
    if (!wrap) return;

    const map = {};

    wrap.querySelectorAll("a").forEach((a) => {
      const raw = txt(a);
      const label = raw === "Salads" ? "Gardencups" : rename[raw] || raw;

      if (!allowed.includes(label)) {
        a.remove();
        return;
      }

      a.textContent = label;
      a.setAttribute("href", `#${anchorId(label)}`);
      a.dataset.pbJump = label;

      if (!map[label]) map[label] = a;
    });

    wrap.innerHTML = "";
    allowed.forEach((label) => {
      if (map[label]) wrap.appendChild(map[label]);
    });

    wrap.querySelectorAll("a[data-pb-jump]").forEach((a) => {
      if (a.dataset.pbJumpBound === "1") return;
      a.dataset.pbJumpBound = "1";

      a.addEventListener("click", (e) => {
        const label = a.dataset.pbJump;
        const target = document.getElementById(anchorId(label));
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        history.replaceState(null, "", `#${anchorId(label)}`);
      });
    });

    wrap.classList.remove('hidden');
  };

  const fixCategoryFilters = () => {
    const cat = document.querySelector(".pb__filter.category");
    if (!cat) return;

    const list = cat.querySelector(".pb__filter-list");
    if (!list) return;

    const keep = new Set(["salads", "soups", "produce", "snacks"]);

    const rows = [];
    list.querySelectorAll("li").forEach((li) => {
      const input = li.querySelector('input[data-type="category"]');
      if (!input) return;

      const val = (input.getAttribute("data-value") || "").trim();
      if (!keep.has(val)) {
        li.remove();
        return;
      }

      const label =
        val === "salads"
          ? "Gardencups"
          : val === "soups"
          ? "Soups"
          : val === "produce"
          ? "Produce"
          : "Snacks";

      const firstText = li.querySelector("label")?.childNodes?.[0];
      if (firstText) firstText.nodeValue = label;

      rows.push({ li, label });
    });

    const map = {};
    rows.forEach((r) => {
      if (!map[r.label]) map[r.label] = r.li;
    });

    list.innerHTML = "";
    allowed.forEach((label) => {
      if (map[label]) list.appendChild(map[label]);
    });
  };

  const removeFilterHeaders = () => {
    document.querySelectorAll('.pb__filter-head, .pb__filter.diet .pb__filter-title').forEach(e => {
        e.remove()
    })
  }

  const addVegetarianTag = () => {
    document.querySelectorAll('.pb__product-info .pb__product-title').forEach(e => {
        if (e.textContent && vegetarianProducts.includes(e.textContent.trim())) {
            const productContainer = e.closest('.pb__product-container')
            if (productContainer.querySelector('.pb__product-badge')) {
                productContainer.querySelector('.pb__product-badge').textContent = 'Vegetarian'
            } else {
                const badge = document.createElement('span')
                badge.className = 'pb__product-badge'
                badge.textContent = 'Vegetarian'

                productContainer.querySelector('.pb__product.card').prepend(badge)
            }
        }
    })
  }

  const getCategoryByValue = (value) => {
    return Object.keys(categoryMap).find(key =>
      categoryMap[key].includes(value)
    );
  }

  const setCategoryInProduct = () => {
    document.querySelectorAll('[data-collection-shopify-id]').forEach(e => {
      const category = getCategoryByValue(e?.closest('[data-category-filter]')?.getAttribute('data-category-filter'));
        if (category) {
          e.setAttribute('data-filter-category', category)
        }
    })

    document.querySelectorAll('[data-product-tags]').forEach(e => {
        e.setAttribute('data-product-tags', e.getAttribute('data-product-tags').toLowerCase())
    })
  }

  const syncCategoryFiltersWithJumpLinks = () => {
    const categoryList = document.querySelector('.pb__filter.category .pb__filter-list');
    if (!categoryList) return;

    const allowedTargets = new Set();
    document.querySelectorAll('.pb__jump-links [data-target]').forEach(link => {
      if (link.style.display === 'none') return;
      const target = (link.getAttribute('data-target') || '').trim().toLowerCase();
      if (target) allowedTargets.add(target);
    });



    categoryList.querySelectorAll('li').forEach(li => {
      const input = li.querySelector('input[data-type="category"]');
      if (!input) return;

      const value = (input.getAttribute('data-value') || '').trim().toLowerCase();
      li.style.display = allowedTargets.has(value) ? '' : 'none';
    });
  }
  
  const overrideFilterFunction = () => {
    const filterButton = document.querySelector('.pb__filters-apply')
    if (!filterButton) return;
    
    filterButton.addEventListener('click', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
    },  true);

    filterButton.addEventListener('pointerdown', e => {
      const selectedCategory = Array.from(document.querySelectorAll('[data-type="category"]:checked')).map(input => input.getAttribute('data-value').toLowerCase());
      const selectedDiet = Array.from(document.querySelectorAll('[data-type="diet"]:checked')).map(input => input.getAttribute('data-value').toLowerCase());
      const allProducts = document.querySelectorAll('.pb__product-container > [data-product-id]');

      if (selectedCategory.length || selectedDiet.length) {
        // Hide all products first
        allProducts.forEach(product => {
          const container = product.closest('.pb__product-container');
          if (container) container.style.display = 'none';
        });

        // Filter products: category uses OR logic, dietary uses AND logic
        allProducts.forEach(product => {
          const container = product.closest('.pb__product-container');
          if (!container) return;

          let matchesCategory = selectedCategory.length === 0;
          let matchesDiet = selectedDiet.length === 0;

          // Category filter: OR logic (match any selected category)
          if (selectedCategory.length > 0) {
            const productCategory = product.getAttribute('data-filter-category');
            if (productCategory) {
              const productCategoryLower = productCategory.toLowerCase();
              matchesCategory = selectedCategory.some(cat => productCategoryLower.includes(cat) || cat.includes(productCategoryLower));
            } else {
              // Check collection category as fallback
              const collection = container.closest('[data-category-filter]');
              if (collection) {
                const collectionCategory = collection.getAttribute('data-category-filter');
                if (collectionCategory) {
                  const collectionCategoryLower = collectionCategory.toLowerCase();
                  matchesCategory = selectedCategory.some(cat => collectionCategoryLower.includes(cat) || cat.includes(collectionCategoryLower));
                }
              }
            }
          }

          // Dietary filter: AND logic (must have ALL selected dietary tags)
          if (selectedDiet.length > 0) {
            const productTags = product.getAttribute('data-product-tags');
            if (productTags && productTags.length > 0) {
              const tagList = productTags
                .split(',')
                .map(tag => tag.trim().toLowerCase())
                .filter(Boolean);
              
              // Check that ALL selected dietary filters appear in the tagList (AND logic)
              matchesDiet = selectedDiet.every(diet => tagList.includes(diet));
            } else {
              matchesDiet = false;
            }
          }

          // Show product if it matches both category (OR) and dietary (AND) filters
          if (matchesCategory && matchesDiet) {
            container.style.display = 'block';
          }
        });

        // Show/hide collections based on visible products
        document.querySelectorAll('[data-category-filter]').forEach(e => {
            e.style.display = 'none'
            e.querySelectorAll('.pb__collection-products .pb__product-container').forEach(productContainer => {
                if (productContainer.style.display != 'none') {
                    e.style.display = 'block'
                }
            })
        })
      } else {
        resetFilter();
      }
      
      const drawerClose = document.querySelector('.pb__drawer-close');
      if (drawerClose) drawerClose.click();
    });
  }

  const resetFilter = () => {
    document.querySelectorAll('.pb__product-container > [data-product-id]').forEach(product => {
      const container = product.closest('.pb__product-container');
      if (container) container.style.display = 'block';
    });
    document.querySelectorAll('[data-category-filter]').forEach(e => {
        e.style.display = 'block'
    })
  }

  const overrideClearFunction = () => {
    const clearButton = document.querySelector('.pb__filters-clear')
    clearButton.addEventListener('pointerdown', e => {
      resetFilter();
      document.querySelector('.pb__drawer-close').click()
    })
  }

  const fixCollectionView = () => {
    const filterButton = document.querySelector('.pb__filters-apply')
    if (!filterButton) return;
    
    filterButton.addEventListener('click', e => {
      e.preventDefault();
      document.querySelector('.pb__collections').classList.add('fadeout');
      setTimeout(() => {
        collections().forEach(collection => {
          const productContainers = collection.querySelectorAll('.pb__collection-products .pb__product-container');
          const hasVisibleProduct = Array.from(productContainers).some(container => {
              return container.style.display !== 'none';
          });
          
          if (hasVisibleProduct) {
              collection.style.display = 'block';
          } else {
              collection.style.display = 'none';
          }
        })
        document.querySelector('.pb__collections').classList.remove('fadeout');
      }, 500);
    },  true);
  }

  const run = () => {
    if (!titlesReady()) return;
    setCategoryInProduct();
    // overrideFilterFunction();
    // overrideClearFunction();
    fixCollectionView();
    mergeGardencups();
    fixHeaders();
    reorderSections();
    ensureSectionAnchors();
    fixJumpLinks();
    syncCategoryFiltersWithJumpLinks();
    // fixCategoryFilters();
    // removeFilterHeaders();
    addVegetarianTag();
  };

  let normalizeTimer = null;

  const scheduleNormalize = () => {
    clearTimeout(normalizeTimer);
    normalizeTimer = setTimeout(run, 140);
  };

  // React dispatches these instead of relying on a subtree MutationObserver (which
  // re-fired on every DOM change from run() and caused continuous mutations).
  window.addEventListener("pb-b2b-collections-mount", scheduleNormalize);
  window.addEventListener("pb-b2b-collections-live", scheduleNormalize);
})();
